/* import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export async function exportSnapshotPdf(
  element: HTMLElement,
  projectName: string,
  snapshotDate: string
) {
  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: "#ffffff",
    scrollY: -window.scrollY,
  });

  const imgData = canvas.toDataURL("image/png");

  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const margin = 10;

  const imgWidth = pageWidth - margin * 2;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = margin;

  
  pdf.addImage(
    imgData,
    "PNG",
    margin,
    position,
    imgWidth,
    imgHeight,
    undefined,
    "FAST"
  );

  heightLeft -= pageHeight - margin * 2;

  
  while (heightLeft > 0) {
    position = heightLeft - imgHeight + margin;

    pdf.addPage();

    pdf.addImage(
      imgData,
      "PNG",
      margin,
      position,
      imgWidth,
      imgHeight,
      undefined,
      "FAST"
    );

    heightLeft -= pageHeight - margin * 2;
  }

  const fileName = `${projectName
    .replace(/[\\/:*?"<>|]/g, "")
    .replace(/\s+/g, "_")}_Snapshot_${snapshotDate}.pdf`;

  pdf.save(fileName);
} */
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export async function exportSnapshotPdf(
  element: HTMLElement,
  projectName: string,
  snapshotDate: string
) {
  const canvas = await html2canvas(element, {
    scale: 3,
    useCORS: true,
    allowTaint: true,
    backgroundColor: "#ffffff",
    scrollY: -window.scrollY,
    windowWidth: element.scrollWidth,
    windowHeight: element.scrollHeight,
  });

  const pdf = new jsPDF("p", "mm", "a4");

  const pageWidth = 210;
  const pageHeight = 297;

  const margin = 10;

  const printableWidth = pageWidth - margin * 2;
  //const printableHeight = pageHeight - margin * 2;
  const printableHeight = pageHeight - margin * 2 - 6;

  // Scale factor from canvas pixels to PDF mm
  const scale = printableWidth / canvas.width;

  // Height (in canvas pixels) that fits on one PDF page
  const pageCanvasHeight = Math.floor(printableHeight / scale);

  let renderedHeight = 0;
  let pageNumber = 0;

  while (renderedHeight < canvas.height) {
    // Create temporary canvas for one page
    const pageCanvas = document.createElement("canvas");

    pageCanvas.width = canvas.width;
    pageCanvas.height = Math.min(
      pageCanvasHeight,
      canvas.height - renderedHeight
    );

    const ctx = pageCanvas.getContext("2d");

    if (!ctx) break;

    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);

    ctx.drawImage(
      canvas,
      0,
      renderedHeight,
      canvas.width,
      pageCanvas.height,
      0,
      0,
      canvas.width,
      pageCanvas.height
    );

    const imgData = pageCanvas.toDataURL("image/png");

    if (pageNumber > 0) {
      pdf.addPage();
    }

    const imgHeight =
      (pageCanvas.height * printableWidth) / pageCanvas.width;

    pdf.addImage(
      imgData,
      "PNG",
      margin,
      margin,
      printableWidth,
      imgHeight,
      undefined,
      "FAST"
    );

    renderedHeight += pageCanvas.height;
    pageNumber++;
  }

  const safeProject = projectName
    .replace(/[\\/:*?"<>|]/g, "")
    .replace(/\s+/g, "_");

  pdf.save(`${safeProject}_Snapshot_${snapshotDate}.pdf`);
}